import React, { useState, useEffect, useContext, useMemo, useRef, use } from 'react';
import { Form, Button, Modal, Dropdown } from 'react-bootstrap';
import ModalComponent from '../../helper_components/ModalComponent';
import Select from 'react-select';
import { selectStylesDefault, fieldsValidation } from '../my_expedients/expedients_list_logic';
import Cookies from 'js-cookie';
import {
  getTemplatesPresaved,
  getUserTemplateById,
  getAgreementTypes,
  requestDeleteTemplate,
  getPromotionsWithoutAgreement,
  renderFieldsPromotionTemplate,
  requestSendUpdateTemplate,
  bodyDeleteTemplate,
  getCommentsByTemplate,
  requestCreatePDFTemplate,
  requestCommentAndRelease,
  getEmailsTemplates,
  getExpedientStakeHolders,
  footerNotifyEmail,
  bodyNotifyEmail,
  requestCreatePDFTemplateOther,
  getStringIdFromASelectArray,
  getAgreementsToNotifyByExpedientId,
  getSelectedOptionsById,
  getIsCommentFieldShowingInTemplate,
  requestUnsignPDFTemplate,
  getJudgesandSecretaries,
  initIaTemplate,
} from '../details_expedient/expedient_details_logic';
import { renderErrorsList, renderClassesToErrors } from '../../edit_profile/edit_profile_logic';
import LoaderContext from '../../layout/shared/loader_context';
import { NotificationManager } from 'react-notifications';
import _, { template } from 'lodash';
import { BulletinFields } from '../details_expedient/components/BulletinFields/BulletinFields';
import ConfirmModal from '../../helper_components/confirm_modal/ConfirmModal';
import TextTooltip from '../../tootip/TextTooltip';
import ElectronicSignatureTemplatesModal from '../details_expedient/modals/ElectronicSignatureTemplatesModal';
import ModalComponentPortal from '../../helper_components/modals/modalComponentPortal/ModalComponentPortal';
import AgreementWithoutPromotionModal from '../details_expedient/modals/AgreementWithoutPromotionModal';
import { templatesTypesToAskIfIsAPublishBulletin } from '../../../services/dataFormatting/templatesTypesToAskIfIsAPublishBulletin';
import ElectronicSignatureProcessProvider, {
  useElectronicSignatureProcessContext,
} from '../../dynamic_form/dynamic_form_types/ElectronicSignatureProcess/context/ElectronicSignatureProcessContext';
import { useTemplatesPresavedContextContext } from '../details_expedient/context/templatesPresavedContext';
import useImagesWithCorsErrorState from '../../richTextEditor/hooks/imagesWithCorsErrorState/useImagesWithCorsErrorState';
import RichTextEditor from '../../richTextEditor/RichTextEditor';
import {
  getLetterheadBackdrop,
  buildLetterheadContentStyle,
} from '../../../services/tinymce/letterheadBackdrop';
import { getLabelFromDictionary } from '../../../config/dictionary';
import useTemplateTabsState from './components/templateTabs/hooks/useTemplateTabsState/useTemplateTabsState';
import TemplateTabsWithWidgets from './components/templateTabsWithWidgets/TemplateTabsWithWidgets';
import { onGetTemplateFile } from '../details_expedient/services/onGetTemplateFile';
import { getFormData } from '../../../services/dataFormatting/getFormData';
import { UserEntity } from '../../../shared/entities/user.entity';
import UsersAndPermissionsListModal from '../details_expedient/modals/UsersAndPermissionsListModal';
import DatePicker, { registerLocale } from 'react-datepicker';
import es from 'date-fns/locale/es';
import CustomInputDate from '../details_expedient/components/CustomInputDate/CustomInputDate';
import { secondCustomHeaderDatePicker } from '../details_expedient/expedient_details_logic';
import moment from 'moment';
import {
  isWeekday,
  holidayDates,
} from '../details_expedient/components/CustomInputDate/CustomDateRules';
import { ATTACHMENT_TYPES } from '../details_expedient/ExpedientDetails';
import TableUploadManyFiles from '../../helper_components/TableUploadManyFiles';
registerLocale('es', es);

const stylesFormatted = {
  ...selectStylesDefault,
  menu: (provided) => ({
    ...provided,
    zIndex: 100,
  }),
};

const getObjectWithoutEmailTemplateId = (object) => {
  const { email_template_id, ...restOfData } = object;
  return restOfData;
};

const selectStylesError = {
  control: (provided) => {
    return {
      ...provided,
      border: '1px solid red',
    };
  },
};

const electronicNotificationInitialState = {
  isAnElectronicNotification: false,
  isAnAgreementType: true,
  isAnJudgmentType: false,
};

const TemplatesPresaved = ({
  expedientNumber,
  reloadData,
  setReloadData,
  reloadParentComponent,
  props,
  dataExpedient,
  reloadExpedientDetailsComponent,
  expedientId,
  onShowCreateTemplateByTypeModal,
  isATurnedExpedient,
  transferState,
  cannotUseSentences,
  handleOpenEditWithIa = () => {},
}) => {
  const { isMultipleSignature } = useElectronicSignatureProcessContext();
  // const isExpedientJudgmentActive = Boolean(_.get(dataExpedient, 'judgment_active'));
  const [loadUploadAnex, setLoadUploadAnex] = useState(false);
  const isExpedientJudgmentActive = true; //TEMPORAL
  const specialPermissions = Cookies.getJSON('special_permissions_03');
  const { userId_03 } = Cookies.get();
  const canUseAgreementTemplate = specialPermissions[0]['agreement_template'] === '1';
  const canUseAgreementTemplateIA = specialPermissions[0]['agreement_template_ia'] === '1';
  const canUseNotificationsTemplate = specialPermissions[0]['notifications_template'] === '1';
  const canUsePromotionsTemplate = specialPermissions[0]['promotions_template'] === '1';
  const canUseJudgmentsTemplate =
    cannotUseSentences !== null
      ? specialPermissions[0]['judgments_template'] === '0'
      : specialPermissions[0]['judgments_template'] === '1';
  const canUseEmailsTemplate = specialPermissions[0]['emails_template'] === '1';
  const canUseWritTemplate = specialPermissions[0]['writ_template'] === '1';
  const areTabsShowing =
    canUseAgreementTemplate ||
    canUseNotificationsTemplate ||
    canUsePromotionsTemplate ||
    canUseJudgmentsTemplate ||
    canUseEmailsTemplate ||
    canUseWritTemplate;
  const canSaveTemplates = specialPermissions[0]['documents_without_sing'] === '1';
  const [showModalTiny, setShowModalTiny] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [agreementTypes, setAgreementTypes] = useState([]);
  const [templateHere, setTemplateHere] = useState({});
  const [templatesAgreement, setTemplatesAgreement] = useState([]);
  const [templatesNotification, setTemplatesNotification] = useState([]);
  const [showConfirmUploadModal, setShowConfirmUploadModal] = useState(false);
  const [templatesEmail, setTemplatesEmail] = useState([]);
  const [templatesWrit, setTemplatesWrit] = useState([]);
  const [templatesJudgment, setTemplatesJudgment] = useState([]);
  const [errors, setErrors] = useState({});
  const loader = useContext(LoaderContext);
  const [templateIdDelete, setTemplateIdDelete] = useState('');
  const [openDeleteTemplate, setOpenDeleteTemplate] = useState(false);
  const [comments, setComments] = useState([]);
  const [openComments, setOpenComments] = useState(false);
  const [emailsOptions, setEmailsOptions] = useState([]);
  const [users, setUsers] = useState([]);
  //const [judgesAndSecretaries, setJudgesAndSecretaries] = useState([]);
  const [currentTemplateId, setCurrentTemplateId] = useState(null);
  const [documentToAssign, setDocumentToAssign] = useState({});
  const [isUsersAndPermissionsListModalShowing, setIsUsersAndPermissionsListModalShowing] =
    useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [newUser, setNewUser] = useState({
    email: '',
    fullname: '',
    id: null,
    canDelete: true,
  });
  const [dataUploadEvidences, setDataUploadEvidences] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isAgreementWithoutPromotionModalShowing, setIsAgreementWithoutPromotionModalShowing] =
    useState(false);
  const shouldTemplateBeSigned = useRef(false);
  const [electronicNotificationState, setElectronicNotificationState] = useState(
    electronicNotificationInitialState
  );
  const shouldAskIfIsAPublishBulletin = useMemo(
    () => templatesTypesToAskIfIsAPublishBulletin.includes(templateHere.type),
    [templateHere.type]
  );
  const [agreementsOrJudgmentsToNotifyOptions, setAgreementsOrJudgmentsToNotifyOptions] = useState(
    []
  );
  const [selectedAgreementsOrJudgmentsToNotify, setSelectedAgreementsOrJudgmentsToNotify] =
    useState([]);
  const richTextPreviousValueRef = useRef('');
  const imagesWithCorsErrorState = useImagesWithCorsErrorState();
  const [holiday, setHoliday] = useState([]);
  const firstInputDatePicker = useRef(null);
  const [dateIsAccepted, setDateIsAccepted] = useState(false);

  const handleIaCreateTemplate = async () => {
    try {
      loader.show(true);
      const iaResult = await initIaTemplate(
        expedientId,
        userId_03,
        'agreement',
        expedientNumber.replace(/-/g, '/')
      );
      if (!iaResult) {
        NotificationManager.error(
          'No fue posible generar el contenido con IA. Inténtalo nuevamente.'
        );
        return;
      }
      if (iaResult.ia_down || !iaResult.ia_url) {
        NotificationManager.warning('El servicio de IA no está disponible en este momento.');
      } else {
        window.open(iaResult.ia_url, '_blank');
        NotificationManager.success(
          'Plantilla creada. Edita el contenido en el editor de IA y búscala en la lista para completar el guardado.'
        );
      }
      setReloadData(!reloadData);
    } catch (e) {
      NotificationManager.error('Error al inicializar la plantilla con IA.');
    } finally {
      loader.show(false);
    }
  };

  const handleOpenEditWithIaPresaved = async (template) => {
    if (template) {
      handleOpenEditWithIa(template);
      onCloseTemplatesPresavedModal();
      await reloadDataTemplates();
    }
  };

  const templateItemsByType = [
    {
      name: 'Agreements',
      list: templatesAgreement,
      displayName: 'Acuerdos',
      isShowing: canUseAgreementTemplate,
      canCreateTemplate: !isATurnedExpedient,
      canUseIATemplate: canUseAgreementTemplateIA,
      icon: 'fas fa-handshake',
      actions: {
        onSelfTemplateClick: setDataTemplateModal,
        onClickDeleteButton: handleOpenDeleteTemplateModal,
        onClickCreateTemplateButton: () => onShowCreateTemplateByTypeModal('agreement'),
        onClickIaCreateTemplateButton: handleIaCreateTemplate,
        onTabClick: handleTemplateTabClick,
        handleOpenEditWithIa: handleOpenEditWithIaPresaved,
      },
    },
    {
      name: 'Notifications',
      list: templatesNotification,
      displayName: 'Notificaciones',
      isShowing: canUseNotificationsTemplate,
      canCreateTemplate: !isATurnedExpedient,
      icon: 'fas fa-bell',
      actions: {
        onSelfTemplateClick: (templateItem) => onClickTemplateBadge(templateItem, true),
        onClickDeleteButton: handleOpenDeleteTemplateModal,
        onClickCreateTemplateButton: () => onShowCreateTemplateByTypeModal('notification'),
        onTabClick: handleTemplateTabClick,
      },
    },
    {
      name: 'Judgments',
      list: templatesJudgment,
      displayName: 'Sentencias',
      isShowing: canUseJudgmentsTemplate && isExpedientJudgmentActive,
      canCreateTemplate: !isATurnedExpedient,
      icon: 'fas fa-gavel',
      actions: {
        onSelfTemplateClick: setDataTemplateModal,
        onClickDeleteButton: handleOpenDeleteTemplateModal,
        onClickCreateTemplateButton: () => onShowCreateTemplateByTypeModal('judgment'),
        onTabClick: handleTemplateTabClick,
      },
    },
    {
      name: 'Emails',
      list: templatesEmail,
      displayName: 'Correos',
      isShowing: canUseEmailsTemplate,
      canCreateTemplate: !isATurnedExpedient,
      icon: 'fas fa-envelope',
      actions: {
        onSelfTemplateClick: setDataTemplateModal,
        onClickDeleteButton: handleOpenDeleteTemplateModal,
        onClickCreateTemplateButton: () => onShowCreateTemplateByTypeModal('email'),
        onTabClick: handleTemplateTabClick,
      },
    },
    {
      name: 'Oficios',
      list: templatesWrit,
      displayName: 'Oficios',
      isShowing: UserEntity.validatePermissions('writ_template'),
      canCreateTemplate: !isATurnedExpedient,
      icon: 'fas fa-envelope',

      actions: {
        onSelfTemplateClick: setDataTemplateModal,
        onClickDeleteButton: handleOpenDeleteTemplateModal,
        onClickCreateTemplateButton: () => onShowCreateTemplateByTypeModal('writ'),
        onTabClick: handleTemplateTabClick,
      },
    },
  ];

  const templateItemsByTypeToShow = templateItemsByType.filter(({ isShowing }) => isShowing);
  const [currentTemplatesTypeName, setCurrentTemplatesTypeName] = useState(
    _.get(templateItemsByTypeToShow, '[0].name', '')
  );
  const currentTemplatesTypeItem = templateItemsByType.find(
    ({ name }) => name === currentTemplatesTypeName
  );
  const doesCurrentTemplatesTypeItemExist = Boolean(currentTemplatesTypeItem);
  const templateTabsState = useTemplateTabsState();
  const especialPermissions = Cookies.getJSON('special_permissions_03');
  const canUploadFileWithoutVisibility =
    especialPermissions &&
    especialPermissions[0] &&
    especialPermissions[0]['omit_mandatory_visibility'] === '1';

  function handleTemplateTabClick(newTemplatesType) {
    setCurrentTemplatesTypeName(newTemplatesType);
  }

  const onIsAPublishBulletinChange = ({ target: { value } }) => {
    const isIncomingValueTrue = value === 'true';
    setErrors(({ ifexcerpt, ...restOfProperties }) => ({ ...restOfProperties }));
    setTemplateHere({ ...templateHere, ifexcerpt: isIncomingValueTrue });
  };

  useEffect(() => {
    if (!agreementsOrJudgmentsToNotifyOptions.length || !templateHere.agreementsOrJudgmentsToNotify)
      return;

    const _selectedAgreementsOrJudgmentsToNotify = getSelectedOptionsById(
      agreementsOrJudgmentsToNotifyOptions,
      templateHere.agreementsOrJudgmentsToNotify
    );
    setSelectedAgreementsOrJudgmentsToNotify(_selectedAgreementsOrJudgmentsToNotify);
  }, [agreementsOrJudgmentsToNotifyOptions]);

  const onNotifycationTypeChange = ({ target }) => {
    setElectronicNotificationState((previousState) => ({
      ...previousState,
      isAnAgreementType: target.value === 'agreement',
      isAnJudgmentType: target.value === 'judgment',
    }));
  };

  useEffect(() => {
    const getAndSetAgreementsOrJudgmentsToNotifyOptions = async () => {
      setSelectedAgreementsOrJudgmentsToNotify([]);
      setTemplateHere({ ...templateHere, agreementsOrJudgmentsToNotify: [] });

      if (electronicNotificationState.isAnAgreementType) {
        loader.show(true);
        const _agreementsOrJudgmentsToNotifyOptions = await getAgreementsToNotifyByExpedientId(
          dataExpedient.id,
          electronicNotificationState.isAnAgreementType ? 'agreement' : 'judgment'
        );
        loader.show(false);
        setAgreementsOrJudgmentsToNotifyOptions(_agreementsOrJudgmentsToNotifyOptions);
      }
    };

    if (
      templateHere.type === 'notification' &&
      (electronicNotificationState.isAnAgreementType ||
        electronicNotificationState.isAnJudgmentType)
    ) {
      getAndSetAgreementsOrJudgmentsToNotifyOptions();
      setTemplateHere({
        ...templateHere,
        notificationType: electronicNotificationState.isAnAgreementType ? 'agreement' : 'judgment',
      });
    }
  }, [
    electronicNotificationState.isAnAgreementType,
    electronicNotificationState.isAnJudgmentType,
    templateHere.type,
  ]);

  const { isElectronicSignatureModalOpen, onOpenElectronicSignatureModal } =
    useTemplatesPresavedContextContext();

  useEffect(() => {
    (async function () {
      loader.show(true);
      await getTemplatesPresaved(
        expedientId,
        setTemplatesAgreement,
        setTemplatesNotification,
        setTemplatesWrit,
        setTemplatesEmail,
        setTemplatesJudgment
      );
      await getAgreementTypes(setAgreementTypes);
      await getPromotionsWithoutAgreement(expedientId, setPromotions);
      setHoliday(await holidayDates());
      loader.show(false);
    })();
  }, [reloadData]);

  const onSignTemplateClick = async () => {
    loader.show(true);
    const areThereTemplateImagesWithCorsError =
      await imagesWithCorsErrorState.getAreThereTemplateImagesWithCorsError(templateHere.body);
    loader.show(false);

    if (areThereTemplateImagesWithCorsError) {
      return;
    }

    const areTemplateFieldsValid = validateTemplateFields();
    if (!areTemplateFieldsValid) {
      return;
    }
    if (
      (!templateHere.all_promotion && templateHere.answer_promotion) ||
      (templateHere.answer_promotion && !templateHere.promotions)
    ) {
      if (templateHere.type === 'agreement') {
        shouldTemplateBeSigned.current = true;
        setIsAgreementWithoutPromotionModalShowing(true);
        return;
      }
    }
    signTemplate();
  };

  useEffect(() => {
    if (templateHere.type !== 'agreement') {
      return;
    }
    if ((promotions && !promotions.length) || !promotions || !templateHere.promotions) {
      return;
    }
    setTemplateHere({
      ...templateHere,
      all_promotion: promotions.length === templateHere.promotions.length,
    });
  }, [promotions, templateHere.promotions]);

  useEffect(() => {
    if (
      Object.keys(documentToAssign).length > 0 &&
      documentToAssign.documentExpedient.document_type !== 'notification'
    ) {
      setIsUsersAndPermissionsListModalShowing(true);
    } else {
      setIsUsersAndPermissionsListModalShowing(false);
    }
  }, [documentToAssign]);

  const signTemplate = () => {
    if (!templateHere.ifexcerpt && templateHere.excerpt) {
      setTemplateHere({ ...templateHere, excerpt: '' });
    }
    onOpenElectronicSignatureModal();
  };

  const handleEditorChange = (e) => {
    delete errors['body'];
    delete errors['html'];
    const richTextCurrentValue = e.content;
    const hasRichTextValueChanged = richTextPreviousValueRef.current !== richTextCurrentValue;

    if (!hasRichTextValueChanged) {
      return;
    }

    richTextPreviousValueRef.current = richTextCurrentValue;
    setTemplateHere({ ...templateHere, body: richTextCurrentValue });
  };

  const sendCommentAndRelease = async (templateId) => {
    const data = {
      expedient_number: expedientNumber.replace(/-/g, '/'),
      comment: templateHere['comments'],
      expedient_id: expedientId,
    };
    const responseValidation = fieldsValidation(['expedient_number', 'comment'], data);
    if (typeof responseValidation === 'object') {
      setErrors(responseValidation);
      console.log('s1');

      NotificationManager.error('Faltan campos requeridos, revisa los campos marcados en rojo');
    } else {
      loader.show(true);
      await requestCommentAndRelease(templateId, data, props);
      loader.show(false);
    }
  };

  const onCloseTemplatesPresavedModal = () => {
    setShowModalTiny(false);
    setSelectedAgreementsOrJudgmentsToNotify([]);
    setAgreementsOrJudgmentsToNotifyOptions([]);
    setTemplateHere({});
    setErrors({});
  };

  const reloadDataTemplates = async () => {
    await getTemplatesPresaved(
      expedientId,
      setTemplatesAgreement,
      setTemplatesNotification,
      setTemplatesWrit,
      setTemplatesEmail,
      setTemplatesJudgment
    );
    await getAgreementTypes(setAgreementTypes);
    await getPromotionsWithoutAgreement(expedientId, setPromotions);
    setUsers([]);
    setShowUsers(false);
  };

  const setIsAnElectronicNotificationToTrueWhenIsATemplatesTypeNotifications = () => {
    if (currentTemplatesTypeName === 'Notifications') {
      const isAnElectronicNotification = true;
      setElectronicNotificationState({
        ...electronicNotificationInitialState,
        isAnElectronicNotification,
      });
      setTemplateHere({ ...templateHere, checkNotification: true });
      return;
    }
    setElectronicNotificationState(electronicNotificationInitialState);
    setTemplateHere({ ...templateHere, checkNotification: false });
    return;
  };

  const reloadParentAndTemplateComponents = async () => {
    loader.show(true);
    const message =
      templateHere['hasProofs'] === 'si'
        ? 'La inserción de la promoción y sus archivos de prueba ha sido exitosa'
        : 'La inserción de la promoción ha sido exitosa';

    await reloadParentComponent(message, 'Excelente:', 5000);
    await reloadDataTemplates();
    setShowModalTiny(false);
    loader.show(false);
  };

  const isCommentFieldShowing = getIsCommentFieldShowingInTemplate(templateHere.type);

  const onSelectRubroChange = (selected) => {
    const agreementsFormatted = selected ? selected.map((p) => p.value) : [];
    const agreementsFormattedLabel = selected ? selected.map((p) => p.label) : [];
    const _alias = agreementsFormattedLabel.toString();
    setTemplateHere({
      ...templateHere,
      alias: _alias,
      headings: agreementsFormatted,
      filename: _alias,
      ...(templateHere.is_from_ia ? { defaultAgreements: selected || [] } : {}),
    });
  };

  const tinyEditor = (
    <div style={{ margin: '0 auto', width: '80%' }}>
      <div style={{ margin: '0 auto', width: '80%' }}>
        <Form>
          <Form.Group>
            <Form.Label>{templateHere['type'] === 'agreement' ? '* Rubro' : '* Nombre'}</Form.Label>
            {templateHere['type'] === 'agreement' &&
            (templateHere.is_from_ia ||
              (templateHere.defaultAgreements && templateHere.defaultAgreements.length > 0)) ? (
              <Select
                id="selectRubro"
                defaultValue={templateHere.is_from_ia ? undefined : templateHere.defaultAgreements}
                value={templateHere.is_from_ia ? templateHere.defaultAgreements || [] : undefined}
                onChange={onSelectRubroChange}
                isClearable={false}
                isMulti
                options={agreementTypes}
                placeholder="Selecciona rubros"
                className="basic-multi-select"
                classNamePrefix="select"
                styles={errors['alias'] ? selectStylesError : stylesFormatted}
              />
            ) : (
              <Form.Control
                onChange={(e) => {
                  delete errors['alias'];
                  setTemplateHere({ ...templateHere, alias: e.target.value });
                }}
                className={renderClassesToErrors(errors, 'alias')}
                placeholder="Agrega un nombre"
                value={templateHere['alias']}
                readOnly
              />
            )}
            {renderErrorsList(errors, 'alias')}
          </Form.Group>

          {templateHere['last_comment'] ? (
            <>
              <hr />
              <Button
                className="fl-r btn-add-comments-template"
                variant="link"
                onClick={() => handleOpenComments()}
              >
                Ver historial de observaciones
              </Button>
              <Form.Group>
                <Form.Label>Última observación:</Form.Label>
                <Form.Control
                  as="textarea"
                  aria-label="Última observación"
                  defaultValue={templateHere['last_comment']}
                  readOnly
                  disabled
                />
              </Form.Group>
            </>
          ) : (
            ''
          )}

          <hr />
          {templateHere['type'] === 'notification' && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>¿Desea hacer una notificación electrónica?</Form.Label>
                <Form.Check
                  type="checkbox"
                  label={'Si'}
                  checked={electronicNotificationState.isAnElectronicNotification}
                  id={'check_isAnElectronicNotification'}
                  onChange={({ target }) => {
                    if (target.checked) {
                      setElectronicNotificationState({
                        ...electronicNotificationInitialState,
                        isAnElectronicNotification: target.checked,
                      });
                      setTemplateHere({
                        ...templateHere,
                        checkNotification: true,
                      });
                    } else {
                      setElectronicNotificationState({
                        ...electronicNotificationInitialState,
                        isAnElectronicNotification: target.checked,
                      });
                      setTemplateHere({
                        ...templateHere,
                        email_template_id: null,
                        checkNotification: false,
                      });
                    }
                  }}
                />
              </Form.Group>
              {electronicNotificationState.isAnElectronicNotification && (
                <>
                  <Form.Group>
                    <Form.Label>* Plantillas de correo electrónico</Form.Label>
                    <Select
                      options={emailsOptions}
                      value={
                        emailsOptions.find(
                          (option) => option.value === templateHere.email_template_id
                        ) || null
                      }
                      onChange={(selected) => {
                        delete errors['email_template_id'];
                        setTemplateHere({
                          ...templateHere,
                          email_template_id: selected.value,
                        });
                      }}
                      placeholder="Selecciona la plantilla para notificar vía correo electrónico"
                      styles={errors['email_template_id'] ? selectStylesError : stylesFormatted}
                      noOptionsMessage={
                        emailsOptions.length > 0
                          ? () => 'Sin opciones disponibles'
                          : () => 'Da de alta primero plantillas de correo'
                      }
                    />
                    {renderErrorsList(errors, 'email_template_id')}
                  </Form.Group>
                  <hr />
                </>
              )}
              <hr />

              <Form.Group onChange={onNotifycationTypeChange}>
                <Form.Label>* Tipo de Notificación</Form.Label>
                <Form.Check
                  type={'radio'}
                  label={'Acuerdo'}
                  value={'agreement'}
                  name={'notificationType'}
                  defaultChecked={electronicNotificationState.isAnAgreementType}
                />
                <Form.Check
                  type={'radio'}
                  label={'Sentencia'}
                  value={'judgment'}
                  name={'notificationType'}
                  defaultChecked={electronicNotificationState.isAnJudgmentType}
                />
                {renderErrorsList(errors, 'notificationType')}
              </Form.Group>
              <hr />

              {electronicNotificationState.isAnAgreementType && (
                <>
                  <Form.Group>
                    <Form.Label>
                      * {electronicNotificationState.isAnAgreementType ? 'Acuerdos' : 'Sentecias'} a
                      notificar:
                    </Form.Label>
                    <Select
                      value={selectedAgreementsOrJudgmentsToNotify}
                      isClearable={false}
                      isMulti
                      options={agreementsOrJudgmentsToNotifyOptions}
                      placeholder={`Selecciona ${
                        electronicNotificationState.isAnAgreementType
                          ? 'los acuerdos a los'
                          : 'las sentencias a las'
                      } cuales quieres notificar`}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      noOptionsMessage={
                        agreementsOrJudgmentsToNotifyOptions.length > 0
                          ? () => 'Sin más opciones disponibles'
                          : () => 'Sin opciones disponibles'
                      }
                      styles={stylesFormatted}
                      onChange={(selected) => {
                        setTemplateHere({
                          ...templateHere,
                          agreementsOrJudgmentsToNotify: getStringIdFromASelectArray(selected),
                        });
                        setSelectedAgreementsOrJudgmentsToNotify(selected);
                      }}
                    />
                    {renderErrorsList(errors, 'agreementsOrJudgmentsToNotify')}
                  </Form.Group>
                  <hr />
                </>
              )}
            </>
          )}

          {templateHere['type'] !== 'notification' && !templateHere['is_from_ia'] && (
            <Form.Group>
              <Form.Label>Solicitar correcciones</Form.Label>
              <Form.Check
                type="checkbox"
                label={'Si'}
                checked={templateHere['add_comments'] ? true : false}
                id={'yes'}
                value={templateHere['add_comments'] ? 'false' : 'true'}
                onChange={(e) => {
                  if (e.target.value === 'true') {
                    setTemplateHere({ ...templateHere, add_comments: true });
                  } else {
                    setTemplateHere({
                      ...templateHere,
                      add_comments: false,
                      comments: '',
                    });
                  }
                }}
              />
            </Form.Group>
          )}

          {templateHere['add_comments'] || templateHere['is_from_ia'] ? (
            <>
              <Form.Group>
                <Form.Label>Observaciones:</Form.Label>
                <Form.Control
                  onChange={(e) =>
                    setTemplateHere({
                      ...templateHere,
                      comments: e.target.value,
                    })
                  }
                  as="textarea"
                  rows="5"
                  aria-label="Observaciones"
                  defaultValue={templateHere['comments']}
                  className={renderClassesToErrors(
                    errors,
                    errors['comment'] ? 'comment' : 'comments'
                  )}
                />
                {renderErrorsList(errors, errors['comment'] ? 'comment' : 'comments')}
                {templateHere && String(templateHere['user_id']) === userId_03 ? (
                  ''
                ) : (
                  <Button
                    onClick={() => sendCommentAndRelease(templateHere['id'])}
                    variant="danger"
                    className="fl-r mT-2 mB-10"
                  >
                    Solicitar corrección
                  </Button>
                )}
              </Form.Group>
            </>
          ) : (
            ''
          )}

          {isCommentFieldShowing && (
            <>
              <hr />
              <Form.Group>
                <Form.Label>Comentarios:</Form.Label>
                <Form.Control
                  onChange={(e) =>
                    setTemplateHere({
                      ...templateHere,
                      comment: e.target.value,
                    })
                  }
                  as="textarea"
                  rows="5"
                  aria-label="Comentarios"
                  defaultValue={templateHere['comment']}
                />
              </Form.Group>
            </>
          )}

          {templateHere['type'] === 'judgment' && (
            <>
              <hr />
              <Form.Group>
                <Form.Label>* Selecciona el tipo de sentencia</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type={'radio'}
                    label={`Interlocutoria`}
                    id={`interlocutory`}
                    className="pl-3"
                    value={'interlocutory'}
                    checked={templateHere && templateHere.judgment_type === 'interlocutory'}
                    onChange={({ target: { value } }) =>
                      setTemplateHere({ ...templateHere, judgment_type: value })
                    }
                  />
                  <Form.Check
                    inline
                    type={'radio'}
                    label={`Definitiva`}
                    id={`definitive`}
                    value={'definitive'}
                    checked={templateHere && templateHere.judgment_type === 'definitive'}
                    onChange={({ target: { value } }) =>
                      setTemplateHere({ ...templateHere, judgment_type: value })
                    }
                  />
                  <Form.Check
                    inline
                    type={'radio'}
                    label={`Segunda instancia`}
                    id={`second_instance_judgment_type_templates`}
                    value={'second_instance'}
                    checked={templateHere && templateHere.judgment_type === 'second_instance'}
                    onChange={({ target: { value } }) =>
                      setTemplateHere({ ...templateHere, judgment_type: value })
                    }
                  />
                </div>
              </Form.Group>
              {renderErrorsList(errors, 'judgment_type')}
            </>
          )}

          {shouldAskIfIsAPublishBulletin && (
            <>
              <Form.Group>
                <Form.Label>* ¿Desea publicar en el boletín?</Form.Label>
                <section>
                  <Form.Check
                    checked={templateHere.ifexcerpt}
                    inline
                    label="Si"
                    name="publishBulletin"
                    type={'radio'}
                    id={'publish-bulletin'}
                    value={true}
                    onChange={onIsAPublishBulletinChange}
                  />
                  <Form.Check
                    checked={!templateHere.ifexcerpt}
                    inline
                    label="No"
                    name="publishBulletin"
                    type={'radio'}
                    id={'do-not-publish-bulletin'}
                    value={false}
                    onChange={onIsAPublishBulletinChange}
                  />
                </section>
                {renderErrorsList(errors, 'ifexcerpt')}
              </Form.Group>
              <hr />
              {(templateHere.ifexcerpt || (templateHere.excerpt && templateHere.ifexcerpt)) && (
                <>
                  {(templateHere['type'] === 'judgment' ||
                    templateHere['type'] === 'agreement') && (
                    <BulletinFields
                      onChange={setTemplateHere}
                      values={templateHere}
                      //judgesAndSecretaries={judgesAndSecretaries}
                      renderErrorsByInputName={renderErrorsList}
                      errors={errors}
                      defaultValues={true}
                      setErrors={setErrors}
                      documentType={templateHere['type']}
                    />
                  )}
                  <Form.Group>
                    <Form.Label>* Extracto para boletín:</Form.Label>
                    {renderErrorsList(errors, 'excerpt')}
                    <Form.Control
                      as="textarea"
                      aria-label="Extracto para boletín"
                      defaultValue={templateHere.excerpt}
                      rows="5"
                      className={renderClassesToErrors(errors, 'excerpt')}
                      onChange={(e) => {
                        setErrors(({ excerpt, ...restOfProperties }) => ({
                          ...restOfProperties,
                        }));
                        setTemplateHere({
                          ...templateHere,
                          excerpt: e.target.value,
                        });
                      }}
                    />
                  </Form.Group>
                  <Form.Group>
                    <Form.Label>* Fecha de publicación a boletín:</Form.Label>
                    <DatePicker
                      renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                      }) =>
                        secondCustomHeaderDatePicker(
                          date,
                          changeYear,
                          changeMonth,
                          decreaseMonth,
                          increaseMonth,
                          prevMonthButtonDisabled,
                          nextMonthButtonDisabled
                        )
                      }
                      dateFormat="dd/MM/yyyy"
                      locale="es"
                      minDate={
                        dataExpedient &&
                        dataExpedient.kind_judgment_id === 59 &&
                        dataExpedient.matter === 'Laboral'
                          ? undefined
                          : new Date()
                      }
                      filterDate={
                        dataExpedient &&
                        dataExpedient.kind_judgment_id === 59 &&
                        dataExpedient.matter === 'Laboral'
                          ? undefined
                          : isWeekday
                      }
                      excludeDates={
                        dataExpedient &&
                        dataExpedient.kind_judgment_id === 59 &&
                        dataExpedient.matter === 'Laboral'
                          ? undefined
                          : holiday
                      }
                      customInput={<CustomInputDate ref={firstInputDatePicker} />}
                      selected={
                        templateHere['publication_date']
                          ? moment(templateHere['publication_date']).toDate()
                          : ''
                      }
                      onChange={(date) => {
                        setTemplateHere({
                          ...templateHere,
                          publication_date: date,
                        });
                        setDateIsAccepted(false);
                      }}
                    />
                    {templateHere['publication_date'] && (
                      <>
                        <p className="text-xs">
                          Elegiste el día:{' '}
                          {moment(templateHere['publication_date']).format('DD/MM/YYYY')}
                        </p>
                        {!dateIsAccepted && (
                          <div className="">
                            <p>¿Estás seguro de que deseas continuar?</p>
                            <span>
                              <button
                                type="button"
                                className="btn btn-xs btn-success ml-2"
                                onClick={() => {
                                  setDateIsAccepted(true);
                                }}
                                // onMouseDown={(e) => e.preventDefault()}
                              >
                                Aceptar
                              </button>
                              <button
                                className="btn btn-xs btn-error ml-2"
                                type="button"
                                onClick={() => {
                                  setTemplateHere({
                                    ...templateHere,
                                    publication_date: '',
                                  });
                                  setDateIsAccepted(false);
                                }}
                                // onMouseDown={(e) => e.preventDefault()}
                              >
                                Cancelar
                              </button>
                            </span>
                          </div>
                        )}
                      </>
                    )}
                    {renderErrorsList(errors, 'publication_date')}
                  </Form.Group>
                  <hr />
                </>
              )}
            </>
          )}

          {templateHere['type'] === 'agreement' && (
            <>
              <Form.Group>
                <Form.Label>* ¿Deseas responder promociones?</Form.Label>
                <Form.Check
                  type="checkbox"
                  label={'Si'}
                  checked={templateHere['answer_promotion'] ? true : false}
                  id={'si'}
                  value={templateHere['answer_promotion'] ? 'false' : 'true'}
                  onChange={(e) => {
                    if (e.target.value === 'true') {
                      setTemplateHere({
                        ...templateHere,
                        answer_promotion: true,
                      });
                    } else {
                      setTemplateHere({
                        ...templateHere,
                        answer_promotion: false,
                      });
                    }
                  }}
                />
              </Form.Group>
              <hr />
            </>
          )}

          {templateHere['answer_promotion'] && templateHere['type'] === 'agreement' ? (
            <>
              <Form.Group>
                <Form.Label>Respuesta a promociones:</Form.Label>
                {(() => {
                  const ids = templateHere.promotions_ids
                    ? templateHere.promotions_ids
                        .toString()
                        .split(',')
                        .map((id) => parseInt(id.trim()))
                    : [];

                  const selectedPromotions = promotions.filter((p) => ids.includes(p.value));

                  return (
                    <Select
                      defaultValue={selectedPromotions}
                      isClearable={false}
                      isMulti
                      options={promotions}
                      placeholder="Selecciona las promociones de este acuerdo"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      noOptionsMessage={
                        promotions.length > 0
                          ? () => 'Sin más opciones disponibles'
                          : () => 'Sin opciones disponibles'
                      }
                      styles={stylesFormatted}
                      onChange={(selectedValues) => {
                        const promotionsFormatted = selectedValues
                          ? selectedValues.map((p) => p.value)
                          : [];
                        setTemplateHere({
                          ...templateHere,
                          answer_promotion: true,
                          promotions_ids: promotionsFormatted.toString(),
                          all_promotion: promotions.length === promotionsFormatted.length,
                        });
                      }}
                    />
                  );
                })()}
              </Form.Group>
              <hr />
            </>
          ) : (
            ''
          )}

          {templateHere['type'] === 'promotion'
            ? renderFieldsPromotionTemplate(
                templateHere,
                setTemplateHere,
                errors,
                setErrors,
                dataExpedient,
                reloadParentAndTemplateComponents,
                dataUploadEvidences
              )
            : ''}

          {(templateHere['type'] === 'judgment' ||
            ATTACHMENT_TYPES.includes(templateHere['type'])) && (
            <Form.Group>
              <Form.Label>* ¿Quieres agregar anexos?</Form.Label>
              <Form.Check
                type="radio"
                label={'Si'}
                checked={templateHere['hasProofs'] === 'si' ? true : false}
                id={'si'}
                value="si"
                onChange={(e) => {
                  setTemplateHere({
                    ...templateHere,
                    hasProofs: e.target.value,
                  });
                }}
              />
              <Form.Check
                type="radio"
                label={'No'}
                checked={templateHere['hasProofs'] === 'no' ? true : false}
                id={'no'}
                value="no"
                onChange={(e) => {
                  setTemplateHere({
                    ...templateHere,
                    hasProofs: e.target.value,
                  });
                }}
              />
              {renderErrorsList(errors, 'hasProofs')}
            </Form.Group>
          )}

          {templateHere['hasProofs'] === 'si' &&
            (templateHere['type'] === 'judgment' ||
              ATTACHMENT_TYPES.includes(templateHere['type'])) && (
              <>
                <Form.Group controlId="formBasicFile">
                  <Form.Label>* Anexos</Form.Label>
                  {renderErrorsList(errors, 'evidence_file')}
                  <TableUploadManyFiles
                    acceptFiles={['.png', '.pdf', '.jpg', '.jpeg']}
                    getFiles={(files) => {
                      if (files.length > 0) {
                        setTemplateHere({
                          ...templateHere,
                          evidence_file: files,
                        });
                        setErrors({
                          ...errors,
                          evidence_file: [],
                        });
                      } else {
                        delete templateHere['evidence_file'];
                      }
                    }}
                    reloadDataComponent={reloadParentComponent}
                    dataUploadEvidences={dataUploadEvidences}
                    expedientId={expedientId}
                    isMultiSignature={isMultipleSignature}
                    loader={loader}
                    setLoadUploadAnex={setLoadUploadAnex}
                  />
                </Form.Group>
              </>
            )}

          {templateHere['type'] === 'agreement' &&
            templateHere['is_from_ia'] &&
            templateHere['ia_id'] && (
              <Form.Group className="mb-5 d-flex justify-content-end">
                <Button
                  onClick={() => handleOpenEditWithIaPresaved(templateHere)}
                  variant="secondary"
                >
                  Abrir editor con IA
                </Button>
              </Form.Group>
            )}
          <Form.Group>
            <Form.Label>* Documento</Form.Label>
            {renderErrorsList(errors, errors['html'] ? 'html' : 'body')}
          </Form.Group>
        </Form>
      </div>

      {/* Fuera del contenedor flex: ahi dentro los editores salen en fila y
          su CSS global fuerza `min-height: 1000px !important`. */}
      {Boolean(templateHere.has_header) && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <div style={{ width: '80%', marginBottom: '12px' }}>
            <Form.Label>Encabezado (se repite en todas las páginas)</Form.Label>
            {/* 300 px: la barra de herramientas ocupa dos filas (~110 px), asi
                que por debajo de eso casi no queda area de escritura. */}
            <div style={{ height: '300px' }}>
              {/* Claves distintas: dos hermanos del mismo componente, uno
                    condicional, para que React no reutilice una instancia. */}
              <RichTextEditor
                key="editor-encabezado"
                value={templateHere.header_content}
                onChange={(e) => setTemplateHere({ ...templateHere, header_content: e.content })}
                height={300}
              />
            </div>
          </div>
        </div>
      )}
      {/* Fuera del contenedor flex: dentro quedaria al lado del editor. */}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '80%' }}>
          <Form.Label>Cuerpo:</Form.Label>
        </div>
      </div>
      <div
        className={
          'container-preview-templates' + (errors['body'] || errors['html'] ? '-error' : '')
        }
        style={{ marginTop: '-10px' }}
      >
        <RichTextEditor
          value={templateHere.body}
          onChange={handleEditorChange}
          imagesWithCorsErrorState={imagesWithCorsErrorState}
          contentStyle={buildLetterheadContentStyle(
            getLetterheadBackdrop(templateHere).backgroundUrl
          )}
        />
      </div>
    </div>
  );

  async function setDataTemplateModal(template, isNotification) {
    setIsAnElectronicNotificationToTrueWhenIsATemplatesTypeNotifications();
    loader.show(true);
    if (isNotification) await getEmailsTemplates(expedientId, setEmailsOptions);
    const _currentTemplateId = template['id'];
    setCurrentTemplateId(_currentTemplateId);
    await getPromotionsWithoutAgreement(expedientId, setPromotions);
    await getUserTemplateById(
      _currentTemplateId,
      setTemplateHere,
      setShowModalTiny,
      agreementTypes
    );
    loader.show(false);
  }

  const onSaveTamplateClick = () => {
    if (
      (!templateHere.all_promotion && templateHere.answer_promotion) ||
      (templateHere.answer_promotion && !templateHere.promotions)
    ) {
      if (templateHere.type === 'agreement') {
        setIsAgreementWithoutPromotionModalShowing(true);
        return;
      }
    }
    handleRequestSave();
  };

  const getTemplateToSend = () => {
    let templateToSend = { ...templateHere };
    if (templateHere.type === 'notification') {
      templateToSend.notificationType = electronicNotificationState.isAnAgreementType
        ? 'agreement'
        : 'judgment';
    }
    if (!templateHere.ifexcerpt && templateHere.excerpt) {
      templateToSend.excerpt = '';
    }
    templateToSend['content'] = templateToSend['body'];
    templateToSend['templateId'] = templateToSend['id'];
    templateToSend['userId'] = Cookies.get('userId_03');
    return templateToSend;
  };

  const validateTemplateFields = () => {
    const requiredFields = templateHere['add_comments']
      ? ['id', 'alias', 'filename', 'type', 'content', 'body', 'expedient', 'comments']
      : ['id', 'alias', 'filename', 'type', 'content', 'body', 'expedient'];

    if (shouldAskIfIsAPublishBulletin && templateHere.ifexcerpt === undefined) {
      requiredFields.push('ifexcerpt');
    }

    if (templateHere.ifexcerpt) {
      requiredFields.push('excerpt');
      requiredFields.push('publication_date');
      if (templateHere['type'] === 'judgment') {
        // requiredFields.push('judgeName');
        // requiredFields.push('agreementsSecretary');
        requiredFields.push('sentenceDate');
        // requiredFields.push('crimes_id');
      }

      // Validar que la fecha de publicación no sea pasada (excepto expedientes laborales)
      const isLaboralExpedient =
        dataExpedient &&
        dataExpedient.kind_judgment_id === 59 &&
        dataExpedient.matter === 'Laboral';
      if (templateHere.publication_date && !isLaboralExpedient) {
        const publicationDate = new Date(templateHere.publication_date);
        publicationDate.setHours(0, 0, 0, 0);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (publicationDate < today) {
          setErrors((prev) => ({
            ...prev,
            publication_date: [
              'La fecha de publicación no puede ser una fecha pasada. Por favor seleccione una fecha válida.',
            ],
          }));
          NotificationManager.error(
            'La fecha de publicación no puede ser una fecha pasada. Por favor seleccione una fecha válida.'
          );
          return false;
        }
      }
    }

    if (templateHere.type === 'judgment') {
      requiredFields.push('judgment_type');
    }

    if (templateHere.type === 'notification') {
      requiredFields.push('notificationType');
      if (electronicNotificationState.isAnAgreementType) {
        requiredFields.push('agreementsOrJudgmentsToNotify');
      }
    }

    let templateToValid = getTemplateToSend();

    if (
      templateHere.hasProofs === 'si' &&
      (!templateHere.evidence_file ||
        !Array.isArray(templateHere.evidence_file) ||
        templateHere.evidence_file.length === 0)
    ) {
      setErrors({
        ...errors,
        evidence_file: ['Debe agregar al menos un anexo'],
      });

      NotificationManager.error('Debe agregar al menos un anexo para continuar');

      return false;
    }

    const responseValidation = fieldsValidation(requiredFields, templateToValid);
    if (typeof responseValidation === 'object') {
      setErrors(responseValidation);
      console.log('response validation', responseValidation);

      console.log('s2');

      NotificationManager.error('Faltan campos requeridos, revisa los campos marcados en rojo');
      return false;
    }
    return true;
  };

  const handleRequestSave = async () => {
    loader.show(true);

    const areThereTemplateImagesWithCorsError =
      await imagesWithCorsErrorState.getAreThereTemplateImagesWithCorsError(templateHere.body);
    if (areThereTemplateImagesWithCorsError) {
      loader.show(false);
      return;
    }

    const areTemplateFieldsValid = validateTemplateFields();
    if (areTemplateFieldsValid) {
      let templateToSend = getTemplateToSend();
      templateToSend = _.omit(
        templateToSend,
        'expedient',
        'filename',
        'type',
        'id',
        'body',
        'defaultAgreements'
      );
      await requestSendUpdateTemplate(templateToSend, setShowModalTiny, setReloadData, reloadData);
    }
    loader.show(false);
  };

  const handleRequestDelete = async () => {
    loader.show(true);
    await requestDeleteTemplate(templateIdDelete, setOpenDeleteTemplate, setReloadData, reloadData);
    setTemplateIdDelete('');
    loader.show(false);
  };

  const handleOpenComments = async () => {
    setShowModalTiny(false);
    await getCommentsByTemplate(templateHere['id'], setComments, setOpenComments);
  };

  const handleCloseComments = () => {
    setOpenComments(false);
    setShowModalTiny(true);
  };

  const getFileTemplate = async (pdfTemplate) => {
    if (canSaveTemplates) {
      try {
        const filetemplate = await onGetTemplateFile(
          pdfTemplate['expedient_template_id'],
          pdfTemplate['html'],
          pdfTemplate['filename']
        );
        pdfTemplate['file'] = filetemplate;
        return pdfTemplate;
      } catch (error) {
        NotificationManager.error(
          'Ha ocurrido un error desconocido, vuelve a intentarlo...',
          '',
          4500
        );
      }
    }
  };

  const handleUsingTemplate = async () => {
    const requiredFields =
      templateHere['type'] === 'notification'
        ? ['expedient_template_id', 'html', 'user_id', 'email_template_id']
        : templateHere['type'] === 'promotion' && templateHere['hasProofs'] !== 'si'
          ? [
              'expedient_template_id',
              'html',
              'user_id',
              'amount_copies',
              'amount_signatures',
              'hasProofs',
            ]
          : templateHere['type'] === 'promotion' && templateHere['hasProofs'] === 'si'
            ? [
                'expedient_template_id',
                'html',
                'user_id',
                'amount_copies',
                'amount_signatures',
                'hasProofs',
                'evidence_file',
              ]
            : templateHere['type'] === 'agreement'
              ? [
                  'expedient_template_id',
                  'html',
                  'user_id',
                  'answer_promotion',
                  'promotions',
                  'file',
                ]
              : ['expedient_template_id', 'html', 'user_id'];

    let pdfToCreate = {
      expedient_template_id: templateHere.id || null,
      html: templateHere.body || '',
      user_id: userId_03 || null,
      comment: templateHere.comments || '',
      filename: templateHere.filename || '',
    };

    if (templateHere['type'] === 'promotion') {
      pdfToCreate = {
        ...pdfToCreate,
        ...templateHere,
      };
    }

    if (
      templateHere['type'] === 'agreement' ||
      templateHere['type'] === 'writ' ||
      templateHere['type'] === 'judgment'
    ) {
      pdfToCreate = {
        ...pdfToCreate,
        ...templateHere,
      };
    }

    pdfToCreate = await getFileTemplate(pdfToCreate);
    const responseValidation = fieldsValidation(requiredFields, pdfToCreate);

    if (typeof responseValidation === 'object') {
      setErrors(responseValidation);
      NotificationManager.error('Faltan campos requeridos, revisa los campos marcados en rojo');
      return responseValidation;
    } else {
      loader.show(true);
      if (templateHere['type'] === 'notification') {
        await insertToExpedientNotificationTemplate();
      } else {
        if (canSaveTemplates) {
          pdfToCreate['FileName'] = `${templateHere['filename']}.pdf`;
          pdfToCreate['filename'] = `${templateHere['filename']}.pdf`;
          pdfToCreate['UserName'] =
            `${(Cookies.get('names_03'), Cookies.get('paternal_surname_03'))}`;
          pdfToCreate['email_template_id'] = templateHere.email_template_id || 0;
          pdfToCreate = getFormData(pdfToCreate);
        }
        await requestUnsignPDFTemplate(
          pdfToCreate,
          setShowModalTiny,
          setReloadData,
          reloadData,
          setErrors,
          reloadParentComponent,
          setDataUploadEvidences,
          setShowConfirmUploadModal
        );
      }
      if (pdfToCreate['type'] !== 'promotion' && pdfToCreate['hasProofs'] !== 'si')
        loader.show(false);
    }

    return {};
  };

  const handleRequestCreate = async () => {
    const requiredFields =
      templateHere['type'] === 'notification'
        ? ['expedient_template_id', 'html', 'user_id', 'email_template_id']
        : templateHere['type'] === 'promotion' && templateHere['hasProofs'] !== 'si'
          ? [
              'expedient_template_id',
              'html',
              'user_id',
              'amount_copies',
              'amount_signatures',
              'hasProofs',
            ]
          : templateHere['type'] === 'promotion' && templateHere['hasProofs'] === 'si'
            ? [
                'expedient_template_id',
                'html',
                'user_id',
                'amount_copies',
                'amount_signatures',
                'hasProofs',
                'evidence_file',
              ]
            : ['expedient_template_id', 'html', 'user_id'];

    let pdfToCreate = {
      expedient_template_id: templateHere.id || null,
      html: templateHere.body || '',
      user_id: userId_03 || null,
      comment: templateHere.comments || '',
    };

    if (templateHere['type'] === 'promotion') {
      pdfToCreate = {
        ...pdfToCreate,
        ...templateHere,
      };
    }

    if (templateHere['type'] === 'agreement') {
      pdfToCreate = {
        ...pdfToCreate,
        ...templateHere,
      };
    }

    const responseValidation = fieldsValidation(requiredFields, pdfToCreate);

    if (typeof responseValidation === 'object') {
      setErrors(responseValidation);
      NotificationManager.error('Faltan campos requeridos, revisa los campos marcados en rojo');
      return responseValidation;
    } else {
      loader.show(true);
      if (templateHere['type'] === 'notification') {
        await insertToExpedientNotificationTemplate();
      } else {
        await requestCreatePDFTemplate(
          pdfToCreate,
          setShowModalTiny,
          setReloadData,
          reloadData,
          setErrors,
          reloadParentComponent,
          setDataUploadEvidences
        );
      }
      if (pdfToCreate['type'] !== 'promotion' && pdfToCreate['hasProofs'] !== 'si')
        loader.show(false);
    }

    return {};
  };

  const insertToExpedientNotificationTemplate = async () => {
    await getExpedientStakeHolders(expedientId, setUsers);
    setShowModalTiny(false);
    setShowUsers(true);
  };

  const handleCloseModalStakeHolders = () => {
    setShowModalTiny(true);
    setShowUsers(false);
  };

  function onClickTemplateBadge(...args) {
    setIsAnElectronicNotificationToTrueWhenIsATemplatesTypeNotifications();
    setElectronicNotificationState(electronicNotificationInitialState);
    setDataTemplateModal(...args);
  }

  const handleRequestInsertNotificationTemplate = async () => {
    loader.show(true);
    const pdfToCreate = {
      expedient_template_id: templateHere.id || null,
      html: templateHere.body || '',
      user_id: userId_03 || null,
      comment: templateHere.comments || '',
      email_template_id: templateHere.email_template_id,
    };
    const dataNotificationEmail = {
      expedient_id: expedientId,
      notification_template_id: templateHere.id,
      emails: users,
    };
    await requestCreatePDFTemplateOther(
      pdfToCreate,
      setErrors,
      dataNotificationEmail,
      reloadParentComponent,
      reloadDataTemplates
    );
    loader.show(false);
  };

  function handleOpenDeleteTemplateModal(templateId) {
    setTemplateIdDelete(templateId);
    setOpenDeleteTemplate(true);
  }

  const renderTitleConfirmModal = (documentType) => {
    switch (documentType) {
      case 'notification':
        return `¿Desea agregar notificación al último acuerdo del ${getLabelFromDictionary('global', 'lowerMainName')}?`;

      case 'promotion':
        return `¿Desea agregar promoción al ${getLabelFromDictionary('global', 'lowerMainName')}?`;

      default:
        return `¿Deseas publicar el documento en el boletín?`;
    }
  };

  const handleRequestPrintTemplate = async (documentKind = null) => {
    loader.show(true);

    const areThereTemplateImagesWithCorsError =
      await imagesWithCorsErrorState.getAreThereTemplateImagesWithCorsError(templateHere.body);
    if (areThereTemplateImagesWithCorsError) {
      loader.show(false);
      return;
    }

    const { authentication_token_03 } = Cookies.get();
    let formData = new FormData();
    formData.append('user_id', userId_03);
    formData.append('template_id', templateHere['id']);
    formData.append('content', templateHere['body']);
    if (documentKind) {
      formData.append('document_kind', documentKind);
    }

    await fetch(
      `${process.env.REACT_APP_URL_API_LARAVEL}/update_download_content_expedient_template`,
      {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: authentication_token_03,
        },
      }
    )
      .then((response) =>
        response.blob().then((blob) => {
          if (blob && blob['type'] && blob['type'] === 'application/pdf') {
            let url = URL.createObjectURL(blob);
            var wnd = window.open(url);
            if (wnd) wnd.print();
            else {
              NotificationManager.warning(
                'Por favor habilita el permiso de abrir ventanas emergentes en este sitio para poder imprimir el documento',
                '¡Necesitamos tu permiso!',
                8000
              );
            }
            setTimeout(() => URL.revokeObjectURL(url), 500);
          } else {
            NotificationManager.error(
              'Ocurrió un error al intentar descargar el documento, inténtalo nuevamente y si el problema persiste contacta al administrador',
              '¡Que mal!',
              5000
            );
          }
        })
      )
      .catch((err) => {
        NotificationManager.error(
          'Ocurrió un error al intentar descargar el documento, inténtalo nuevamente y si el problema persiste contacta al administrador',
          '¡Que mal!',
          5000
        );
      });
    loader.show(false);
  };

  const handlePrintTemplateClick = () => {
    if (templateHere.type === 'agreement') {
      handleRequestPrintTemplate('private');
      return;
    }
    handleRequestPrintTemplate();
  };

  return (
    <>
      {areTabsShowing && (
        <div className="my-5">
          <TemplateTabsWithWidgets
            templateTabsState={templateTabsState}
            templateItemsByType={templateItemsByTypeToShow}
            templatesTypeName={currentTemplatesTypeName}
            templatesTypeItem={currentTemplatesTypeItem}
            doesCurrentTemplatesTypeItemExist={doesCurrentTemplatesTypeItemExist}
          />
        </div>
      )}

      <ModalComponentPortal
        header={`Plantilla guardada de tipo ${
          templateHere['type'] === 'agreement'
            ? 'acuerdo:'
            : templateHere['type'] === 'notification'
              ? 'notificación:'
              : templateHere['type'] === 'judgment'
                ? 'sentencia:'
                : templateHere['type'] === 'promotion'
                  ? 'promoción:'
                  : templateHere['type'] === 'writ'
                    ? 'oficio:'
                    : 'correo electrónico:'
        }`}
        body={tinyEditor}
        footer={
          <>
            <Button variant="secondary" onClick={() => setShowModalTiny(false)}>
              Cerrar
            </Button>
            {templateHere['type'] !== 'email' && canSaveTemplates == false && (
              <TextTooltip text={'Firma electrónica'}>
                <Button
                  variant="warning"
                  onClick={onSignTemplateClick}
                  disabled={
                    (templateHere['type'] === 'agreement' || templateHere['type'] === 'judgment') &&
                    !dateIsAccepted &&
                    templateHere.ifexcerpt
                  }
                >
                  <i className="ti-pencil-alt" />
                </Button>
              </TextTooltip>
            )}

            {templateHere['type'] !== 'email' && canSaveTemplates ? (
              <TextTooltip text={'Guardar'}>
                <Button
                  variant="info"
                  disabled={
                    (templateHere['type'] === 'agreement' || templateHere['type'] === 'judgment') &&
                    !dateIsAccepted &&
                    templateHere.ifexcerpt
                  }
                  onClick={() => setShowConfirmUploadModal(true)}
                >
                  <i className="fas fa-file-upload" />
                </Button>
              </TextTooltip>
            ) : (
              ''
            )}

            <TextTooltip text={'Guardar'}>
              <Button
                variant="success"
                onClick={onSaveTamplateClick}
                disabled={
                  (templateHere['type'] === 'agreement' || templateHere['type'] === 'judgment') &&
                  !dateIsAccepted &&
                  templateHere.ifexcerpt
                }
              >
                <i className="fas fa-save" />
              </Button>
            </TextTooltip>
            {templateHere['type'] === 'judgment' ? (
              <TextTooltip text={'Imprimir'} placement={'right'}>
                <Dropdown>
                  <Dropdown.Toggle variant="dark" id="dropdown-basic">
                    <i className="fas fa-print" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleRequestPrintTemplate('public')}>
                      Publico
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => handleRequestPrintTemplate('private')}>
                      Privado
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </TextTooltip>
            ) : (
              <TextTooltip text={'Imprimir'}>
                <Button variant="dark" onClick={handlePrintTemplateClick}>
                  <i className="fas fa-print" />
                </Button>
              </TextTooltip>
            )}
          </>
        }
        isModalShowing={showModalTiny}
        onHide={onCloseTemplatesPresavedModal}
      />

      {isElectronicSignatureModalOpen && (
        <ElectronicSignatureProcessProvider
          key={currentTemplateId}
          isOnlyOneSignaturePerUserActivated={true}
        >
          <ElectronicSignatureTemplatesModal
            htmlOfDocumentToSign={templateHere.body}
            expedientTemplateId={currentTemplateId}
            templateName={templateHere.filename}
            ExpedientId={expedientId}
            setReloadTemplatesData={setReloadData}
            onCloseTemplateModal={onCloseTemplatesPresavedModal}
            reloadExpedientDetailsComponent={reloadExpedientDetailsComponent}
            userId={templateHere.user_id}
            electronicNotificationState={electronicNotificationState}
            setShowModalTiny={setShowModalTiny}
            templateData={
              templateHere.email_template_id
                ? templateHere
                : getObjectWithoutEmailTemplateId(templateHere)
            }
            setTemplateData={setTemplateHere}
            dataExpedient={dataExpedient}
            emailTemplateId={templateHere.email_template_id}
            setIsUsersAndPermissionsListModalShowing={setIsUsersAndPermissionsListModalShowing}
            setDocumentToAssign={setDocumentToAssign}
            transferState={transferState}
          />
        </ElectronicSignatureProcessProvider>
      )}
      {isUsersAndPermissionsListModalShowing && (
        <UsersAndPermissionsListModal
          isModalShowing={isUsersAndPermissionsListModalShowing}
          setModalShowing={setIsUsersAndPermissionsListModalShowing}
          document={documentToAssign.documentExpedient}
          expedientId={expedientId}
          asign={true}
        />
      )}

      <ModalComponent
        header="¿Estás seguro de eliminar este elemento?"
        body={bodyDeleteTemplate}
        footer={
          <>
            <Button variant="secondary" onClick={() => setOpenDeleteTemplate(false)}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={() => handleRequestDelete()}
              id="delete-template-button"
            >
              Eliminar
            </Button>
          </>
        }
        show={openDeleteTemplate}
        canClose={true}
        onHide={setOpenDeleteTemplate}
      />

      <ModalComponent
        header="Notificar vía correo electrónico:"
        body={bodyNotifyEmail(users, setUsers, newUser, setNewUser)}
        footer={footerNotifyEmail(
          handleCloseModalStakeHolders,
          handleRequestInsertNotificationTemplate
        )}
        show={showUsers}
        canClose={true}
        onHide={handleCloseModalStakeHolders}
        scroll={true}
        dialogClassName="modal-notify-email"
      />

      <Modal
        show={openComments}
        onHide={() => handleCloseComments()}
        animation={false}
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>Historial de comentarios</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table
            className="table table-collapsed"
            style={{
              border: '1px solid #a2a2a2',
              marginTop: '10px',
            }}
          >
            <tbody>
              <tr>
                <th className="text-center button-see-evidence-documents">Creado por:</th>
                <th className="text-center button-see-evidence-documents">Comentario:</th>
                <th className="text-center button-see-evidence-documents">Fecha:</th>
              </tr>
              {comments.map((comment, index) => (
                <tr key={index}>
                  <td style={{ paddingTop: '15px', maxWidth: '150px' }} className="text-center">
                    <small>{comment['user']}</small>
                  </td>
                  <td style={{ paddingTop: '15px', maxWidth: '150px' }} className="text-justify">
                    {comment['comment']}
                  </td>
                  <td style={{ paddingTop: '15px' }} className="text-center">
                    <small>{new Date(comment['createdAt']).toLocaleString('es-MX')}</small>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseComments()}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmModal
        showModal={showConfirmModal}
        setShowModal={setShowConfirmModal}
        title={'Publicar documento'}
        bodyText={renderTitleConfirmModal(templateHere['type'])}
        confirmCallback={async () => {
          const responseCreate = await handleRequestCreate();
          if (!_.isEmpty(responseCreate)) {
            setShowModalTiny(true);
          }
          setShowConfirmModal(false);
        }}
        cancelCallback={() => {
          setShowConfirmModal(false);
          setShowModalTiny(true);
        }}
      />

      {showConfirmUploadModal && (
        <ConfirmModal
          showModal={showConfirmUploadModal}
          setShowModal={setShowConfirmUploadModal}
          title={'Guardar documento'}
          bodyText={'El documento será cargado al expediente y no se podrá modificar'}
          confirmCallback={async () => {
            await handleUsingTemplate();
          }}
          cancelCallback={() => setShowConfirmUploadModal(false)}
        />
      )}

      <AgreementWithoutPromotionModal
        onCancelClick={() => {
          shouldTemplateBeSigned.current = false;
          setIsAgreementWithoutPromotionModalShowing(false);
        }}
        onAcceptClick={async () => {
          if (shouldTemplateBeSigned.current) {
            signTemplate();
            shouldTemplateBeSigned.current = false;
          } else {
            await handleRequestSave();
          }
          setIsAgreementWithoutPromotionModalShowing(false);
        }}
        onOutsideClick={() => {
          shouldTemplateBeSigned.current = false;
          setIsAgreementWithoutPromotionModalShowing(false);
        }}
        isModalShowing={isAgreementWithoutPromotionModalShowing}
      />
    </>
  );
};

export default TemplatesPresaved;
